<template>
  <tbody>
    <tr class="tr-row" :class="rowClasses" @click="toggle">
      <td class="tr-check" @click.stop>
        <label class="form-checkbox">
          <input type="checkbox" :checked="checked" :disabled="!selectable"
                 @change="$emit('check', $event.target.checked)">
          <i class="form-icon"></i>
        </label>
      </td>
      <td class="tr-num">{{ item.date | date('DD/MM/YY HH:mm') }}</td>
      <td class="tr-name">
        {{ item.patient ? item.patient.name : '—' }}
        <span class="tr-sub">Recibo {{ item.code || '—' }}</span>
      </td>
      <td>
        {{ item.expense ? item.expense.name : '—' }}
        <span class="tr-pill tr-pill-gray" v-if="zeroReasonLabel">{{ zeroReasonLabel }}</span>
        <span class="tr-pill tr-pill-error" v-else-if="noRule">Sem regra</span>
      </td>
      <td class="text-right tr-num">{{ item.received | currency }}</td>
      <td class="text-right tr-num hide-sm">{{ ruleLabel(item.rule) }}</td>
      <td class="text-right tr-num" :class="{'text-bold': item.transfer > 0}">
        {{ item.transfer | currency }}
      </td>
      <td>
        <template v-if="noRule">
          <span class="text-error">Cadastrar repasse no serviço</span>
        </template>
        <template v-else-if="zeroReasonLabel">
          <span class="text-gray">Sem repasse</span>
        </template>
        <template v-else>
          <status-pill :status="item.status"/>
          <span class="tr-sub" v-if="item.status === 'paid' && item.paidAt">
            {{ item.paidAt | date }}
          </span>
          <span class="tr-sub" v-else-if="item.status === 'consolidated' && document">
            {{ document }}
          </span>
        </template>
      </td>
      <td class="text-right text-nowrap" @click.stop>
        <template v-if="item.status === 'pending'">
          <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                  data-tooltip="Ver recibo do caixa" :class="{loading: printingEntry}"
                  :disabled="printingEntry" @click="$emit('open-entry', item)">
            <fa-icon :icon="['fal', 'eye']"/>
          </button>
        </template>
        <template v-else>
          <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                  :data-tooltip="payTooltip" :disabled="!payable"
                  @click="$emit('pay', item)">
            <fa-icon :icon="['fal', 'hand-holding-usd']"/>
          </button>
          <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                  data-tooltip="Recibo do repasse" :disabled="!canPrint || !item.bundleId"
                  @click="$emit('print', item)">
            <fa-icon :icon="['fal', 'print']"/>
          </button>
        </template>
      </td>
    </tr>
    <tr class="tr-calc-wrap" v-if="expanded">
      <td colspan="9">
        <calc-detail :item="item"/>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';
import StatusPill from './StatusPill.vue';
import CalcDetail from './CalcDetail.vue';
import { ruleLabel, zeroReasons, isSelectable } from '../helpers';

export default {
  components: {
    StatusPill,
    CalcDetail,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    canPay: {
      type: Boolean,
      default: false,
    },
    canPrint: {
      type: Boolean,
      default: false,
    },
    document: {
      type: String,
      default: null,
    },
    printingEntry: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    selectable() {
      return isSelectable(this.item);
    },
    zeroReasonLabel() {
      return zeroReasons[this.item.zeroReason] || null;
    },
    noRule() {
      return this.item.status === 'pending' && !this.item.zeroReason && !(this.item.transfer > 0);
    },
    rowClasses() {
      return {
        expanded: this.expanded,
        active: this.checked,
        paid: this.item.status === 'paid',
        zero: !!this.zeroReasonLabel || this.noRule,
      };
    },
    payable() {
      return this.canPay && this.item.status !== 'paid' && !!this.item.financialId;
    },
    payTooltip() {
      if (this.item.status === 'paid') {
        return this.item.paidAt ? `Pago em ${moment(this.item.paidAt).format('L')}` : 'Pago';
      }
      return this.canPay ? 'Pagar' : 'Sem permissão para pagar';
    },
  },
  methods: {
    ruleLabel,
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
